import API from '~/enums/API';

const AppConfig = {
  inventoryReportGroups: ['contentId', 'dateTime'],
  geographyReportGroups: ['countryId', 'state', 'city'],
  snackbarAutoHideDuration: 10000,
  forms: {
    defaults: {
      mode: 'onBlur',
      revalidateMode: 'onBlur',
    },
    setValueProps: {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    },
    dateFormat: 'YYYY-MM-DD HH:mm',
    timeFormat: 'HH:mm',
    variant: 'standard',
  },
  Chip: {
    variant: 'outlined',
  },
  secureAdServer: {
    demandOverview: {
      cache: {
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
      },
      endpoints: {
        directDeals: API.DIRECT_DEALS,
        adxDeals: API.ADX_LINE_ITEMS_LISTING,
        networkLineItems: API.NETWORK_LINE_ITEMS_LISTING,
        inhousePromotions: API.INHOUSE_PROMOTIONS_LISTING,
      },
    },
  },
};

export default AppConfig;
